// Código de la mesa en la que está el Cliente (llega en el QR como `?k=`, o
// escrito a mano en la pantalla de inicio). Se guarda al entrar para que las
// pantallas siguientes (carrito, pedidos) sigan teniendo acceso sin volver a
// escanear, y viaja en el header X-Table-Code de cada llamada a pedidos/pagos
// — el backend lo exige al Cliente anónimo (tables/access.py).
const TABLE_ACCESS = "tableAccess";

export function saveTableAccess(number, code) {
  localStorage.setItem(
    TABLE_ACCESS,
    JSON.stringify({ number: String(number), code })
  );
}

// Solo devuelve el código si corresponde a esa mesa.
export function getTableAccessCode(number) {
  try {
    const access = JSON.parse(localStorage.getItem(TABLE_ACCESS));
    return access && access.number === String(number) ? access.code : null;
  } catch (error) {
    return null;
  }
}

export function clearTableAccess() {
  localStorage.removeItem(TABLE_ACCESS);
}

export function tableCodeHeader() {
  try {
    const access = JSON.parse(localStorage.getItem(TABLE_ACCESS));
    return access?.code ? { "X-Table-Code": access.code } : {};
  } catch (error) {
    return {};
  }
}
